/** Liefert ein Array von ganzen Zahlen zurück, die sich zwischen Start- und Endwert befinden, inkl. beider Werte
 * @alias task.createArrayFromRange
 * @param {number} start Startzahl
 * @param {number} end Endzahl
 * @returns {Array.<number>}
 */
export default function createArrayFromRange(start, end)
{
    const array = [];

    if (end > start)
    {
        for (let i = start; i <= end; i++)
        {
            array.push(i);
        }
    }
    else if (start > end)
    {
        for (let i = start; i >= end; i--)
        {
            array.push(i);
        }
    }
    else
    {
        array.push(start);
    }

    return array;
}
